import {
  type InferOutput,
  any,
  array,
  boolean,
  date,
  nullable,
  nullish,
  number,
  object,
  optional,
  picklist,
  string,
  union,
} from "valibot"

export const PensionCategoriesEnum = {
  EDUCATION: "EDUCATION",
  MANAGERS: "MANAGERS",
  INVESTMENT: "INVESTMENT",
  CHILDSAVING: "CHILDSAVING",
  PENSION: "PENSION",
  PROVIDENT: "PROVIDENT",
  COMPREHENSIVE: "COMPREHENSIVE",
  COMPERHENSIVE: "COMPERHENSIVE",
  SUPPLEMENTARY: "SUPPLEMENTARY",
  INSURANCE: "INSURANCE",
  OTHER: "OTHER",
} as const

export type PensionCategoriesEnum = (typeof PensionCategoriesEnum)[keyof typeof PensionCategoriesEnum]

export const DepositTypeEnum = {
  PITZUIM: "PITZUIM", // פיצויים
  TAGMULIM_OVED: "TAGMULIM_OVED", // תגמולים עובד
  TAGMULIM_MAAVID: "TAGMULIM_MAAVID", // תגמולים מעביד
  TAGMULIM_47: "TAGMULIM_47", // תגמולים47
  OVDAN_KOSHER_AVODA: "OVDAN_KOSHER_AVODA", // אבדן כושר עבודה
  SHONOT_OVED: "SHONOT_OVED", // שונות עובד
  SHONOT_MAAVID: "SHONOT_MAAVID", // שונות מעביד
  KEREN_HISHTALMUT_OVED: "KEREN_HISHTALMUT_OVED", // קה"ש עובד
  KEREN_HISHTALMUT_MAAVID: "KEREN_HISHTALMUT_MAAVID", // קה"ש מעביד
  TAGMULIM_PRAT: "TAGMULIM_PRAT", // תגמולים פרט
  RISK_MAVET: "RISK_MAVET", // ריסק מוות (ללא חסכון)
  CHISACHON_LECHOL_YELED: "CHISACHON_LECHOL_YELED", // חיסכון לכל ילד
} as const

export type DepositTypeEnum = (typeof DepositTypeEnum)[keyof typeof DepositTypeEnum]

export const DepositorTypeEnum = {
  EMPLOYEE: "EMPLOYEE",
  CURRENT_EMPLOYER: "CURRENT_EMPLOYER",
  PREVIOUS_EMPLOYER: "PREVIOUS_EMPLOYER",
  NATIONAL_INSURANCE: "NATIONAL_INSURANCE",
  PARENTS: "PARENTS",
  EMPLOYEE_PAST: "EMPLOYEE_PAST",
} as const

export const PosStandType = {
  EMPLOYEE: "EMPLOYEE", // שכיר
  SELF_EMPLOYED: "SELF_EMPLOYED", // עצמאי
  CONTROLLING_OWNER: "CONTROLLING_OWNER", // בעל שליטה
  PRIVATE: "PRIVATE", // פרט
  CUSTOM: "CUSTOM", // מותאם
  OTHER: "OTHER", // אחר
} as const

export type PosStandType = (typeof PosStandType)[keyof typeof PosStandType]

export const WaiverStatusType = {
  NOT_EXISTS: "NOT_EXISTS", // לא קיים
  FULL_WAIVER: "FULL_WAIVER", // קיים ויתור מלא
  CHILDREN_ONLY: "CHILDREN_ONLY", // ילדים בלבד
  SPOUSE_ONLY: "SPOUSE_ONLY", // בן/בת זוג בלבד
} as const

export type WaiverStatusType = (typeof WaiverStatusType)[keyof typeof WaiverStatusType]

export const InvestmentPlanSchema = object({
  holdingPercentage: nullable(number()),
  amount: number(),
  fundId: string(),
  fundShortText: string(),
  finqRank: number(),
  finqRiskLevel: number(),
  companyLogo: string(),
  companyShortText: string(),
})

export const PolicyStatusEnum = {
  ACTIVE: "ACTIVE", // פעיל
  INACTIVE: "INACTIVE", // לא פעיל
  CANCELLED: "CANCELLED", // מבוטל
  UNDER_CLAIM: "UNDER_CLAIM", // בתביעה
  TEMPORARY_RISK: "TEMPORARY_RISK", // ריסק זמני
  PERIOD_EXPIRED: "PERIOD_EXPIRED", // תום תקופה
  BLOCKED_FOR_DEPOSITS: "BLOCKED_FOR_DEPOSITS", // חסום להפקדות
  AUTOMATIC_TEMPORARY_RISK: "AUTOMATIC_TEMPORARY_RISK", // ריסק זמני אוטומטי
  INSURANCE_COVERAGE_KEEPING: "INSURANCE_COVERAGE_KEEPING", // שמירת כיסוי ביטוחי
  NOT_RELEVANT: "NOT_RELEVANT", // לא רלוונטי
} as const

export type PolicyStatusEnum = (typeof PolicyStatusEnum)[keyof typeof PolicyStatusEnum]

export const InsuranceCoverageTypeEnum = {
  DEATH_COVERAGE: "DEATH_COVERAGE", // 1
  DISABILITY_COVERAGE: "DISABILITY_COVERAGE", // 2
  ACCIDENTAL_DEATH: "ACCIDENTAL_DEATH", // 3
  ACCIDENTAL_DISABILITY: "ACCIDENTAL_DISABILITY", // 4
  WORK_DISABILITY: "WORK_DISABILITY", // 5
  RELEASE: "RELEASE", // 6
  DEATH_DISEASE: "DEATH_DISEASE", // 7
  PENSION_SAVINGS: "PENSION_SAVINGS", // 8
  PENSION_SAVINGS_WITH_RISK: "PENSION_SAVINGS_WITH_RISK", // 9
  OTHER: "OTHER", // 10
} as const

export type InsuranceCoverageTypeEnum = keyof typeof InsuranceCoverageTypeEnum

export const InsuredTypeEnum = {
  PRIMARY: "PRIMARY",
  SECONDARY: "SECONDARY",
  CHILD: "CHILD",
  MUTUAL: "MUTUAL",
  OTHER: "OTHER",
} as const

export type InsuredTypeEnum = keyof typeof InsuredTypeEnum //SUG - MEVUTACH

export const InsurancePolicyPaymentMethodEnum = {
  BANK_TRANSFER: "BANK_TRANSFER", // העברה בנקאית
  DIRECT_DEBIT: "DIRECT_DEBIT", // הוראת קבע
  CREDIT_CARD: "CREDIT_CARD", // כרטיס אשראי
  OTHER: "OTHER", // אחר
  CHECK: "CHECK", // המחאה
} as const

export type InsurancePolicyPaymentMethodEnum = keyof typeof InsurancePolicyPaymentMethodEnum

export const InsurancePolicyPaymentFrequencyEnum = {
  MONTHLY: "MONTHLY", // חודשי
  QUARTERLY: "QUARTERLY", // רבע שנתי
  SEMI_ANNUALLY: "SEMI_ANNUALLY", // חצי שנתי
  ANNUALLY: "ANNUALLY", // שנתי
  ONE_TIME: "ONE_TIME", // חד פעמי
} as const

export type InsurancePolicyPaymentFrequencyEnum = keyof typeof InsurancePolicyPaymentFrequencyEnum

export const InsuranceCoveragePaymentMethodEnum = {
  ONE_TIME_AMOUNT: "ONE_TIME_AMOUNT", // One-time payment amount
  ALLOWANCE: "ALLOWANCE", // Pension
  PERIODIC_PAYMENTS: "PERIODIC_PAYMENTS", // Periodic payments
  OTHER: "OTHER", // Other
  WEALTH_AND_ALLOWANCE: "WEALTH_AND_ALLOWANCE", // Capital and pension
} as const

export type InsuranceCoveragePaymentMethodEnum = keyof typeof InsuranceCoveragePaymentMethodEnum

export const InsuranceTypeOnManufacturerEnum = {
  BASIC: "BASIC",
  RIDER: "RIDER",
} as const

export type InsuranceTypeOnManufacturerEnum = keyof typeof InsuranceTypeOnManufacturerEnum

export const DevelopmentalDisabilityEnum = {
  ONE_PERCENTAGE: "ONE_PERCENTAGE",
  TWO_PERCENTAGE: "TWO_PERCENTAGE",
  NONE: "NONE",
} as const
export type DevelopmentalDisabilityEnum = keyof typeof DevelopmentalDisabilityEnum

export const pensionInsuranceCoveragesSchema = object({
  monthlyDisabilityAllowance: number(),
  disabilityMonthlyCost: number(),
  sheerimMonthlyCost: number(),
  salaryRate: number(),
  insuranceCoverageWaiver: boolean(),
  disabilityExtension: boolean(),
  salaryForDisabilityAndSheerim: number(),
  sheerimWaiverType: picklist(Object.values(WaiverStatusType)),
  sheerimWaiverEndDate: string(),
  sheerimWidowerAllowance: number(),
  widowerCoverageRate: number(),
  sheerimOrphanAllowance: number(),
  orphanCoverageRate: number(),
  sheerimSupportedParentAllowance: number(),
  supportedParentCoverageRate: number(),
  maxSheerimAllowance: number(),
})

export type PensionInsuranceCoverages = InferOutput<typeof pensionInsuranceCoveragesSchema>

export const WealthSchema = union([
  object({}),
  object({
    taxExemptBefore2002: optional(number()),
    withinTaxCeilingFrom2003: optional(number()),
    aboveTaxCeiling: optional(number()),
  }),
])
export type CurrentSavingsWealth = InferOutput<typeof WealthSchema>

export const AllowanceSchema = union([
  object({}),
  object({
    currentEmployerCompensation: optional(number()),
    pastEmployerCompensation: optional(number()),
    employeeTagmulim: optional(number()),
    employerTagmulim: optional(number()),
  }),
])

export type CurrentSavingsAllowance = InferOutput<typeof AllowanceSchema>

export const CurrentSavingsInfo = { wealth: WealthSchema, allowance: AllowanceSchema } as const
export const CurrentSavingsInfoSchema = optional(object(CurrentSavingsInfo))

export type CurrentSavingsInfo = InferOutput<typeof CurrentSavingsInfoSchema>

export const BasicInsuranceCoverageTrackTypeEnum = {
  BASIC_TRACK: "BASIC_TRACK", // מסלול יסודי
  INDEXED_AMOUNT: "INDEXED_AMOUNT", // סכום ביטוח מבוקש צמוד למדד
  SALARY_MULTIPLES: "SALARY_MULTIPLES", // כפולות משכורות
  SAVINGS_PERCENTAGE: "SAVINGS_PERCENTAGE", // הקצאה לחיסכון באחוזים
  PURE_SAVINGS: "PURE_SAVINGS", // חיסכון טהור
} as const

export type BasicInsuranceCoverageTrackTypeEnum = keyof typeof BasicInsuranceCoverageTrackTypeEnum

export const InsuranceCoveragePayerEnum = {
  EMPLOYER: "EMPLOYER", // מעסיק
  EMPLOYEE: "EMPLOYEE", // עובד
  EMPLOYER_WITH_SALARY_PERCENTAGE_CAP: "EMPLOYER_WITH_SALARY_PERCENTAGE_CAP", // מעסיק עם תקרה של אחוז מהשכר
  EMPLOYER_WITH_SALARY_PERCENTAGE_CAP_EMPLOYEE_REMAINDER:
    "EMPLOYER_WITH_SALARY_PERCENTAGE_CAP_EMPLOYEE_REMAINDER", // מעסיק עם תקרה של אחוז מהשכר והיתרה ע"ח העובד
  EMPLOYER_WITH_SALARY_PERCENTAGE_CAP_SAVINGS_REMAINDER:
    "EMPLOYER_WITH_SALARY_PERCENTAGE_CAP_SAVINGS_REMAINDER", // מעסיק עם תקרה של אחוז מהשכר והיתרה ע"ח הפרשות
  FROM_SAVINGS: "FROM_SAVINGS", // מתוך ההפרשות
} as const

export type InsuranceCoveragePayerEnum = keyof typeof InsuranceCoveragePayerEnum

export const BasicInsuranceCoveragePayerEnum = {
  EMPLOYER_MISC_BUDGET: "EMPLOYER_MISC_BUDGET", // מעסיק תקציב שונות
  EMPLOYEE_MISC_BUDGET: "EMPLOYEE_MISC_BUDGET", // עובד תקציב שונות
  FROM_SAVINGS: "FROM_SAVINGS", // מתוך החיסכון
} as const

export type BasicInsuranceCoveragePayerEnum = keyof typeof BasicInsuranceCoveragePayerEnum

export const PersonalAndGroupTypeEnum = {
  PERSONAL: "PERSONAL", // כן - Yes
  GROUP: "GROUP", // לא - No
  PERSONAL_AND_GROUP: "PERSONAL_AND_GROUP", // לא ידוע - Unknown
} as const

// Type for the DiscountExistsEnum
export type PersonalAndGroupTypeEnum =
  (typeof PersonalAndGroupTypeEnum)[keyof typeof PersonalAndGroupTypeEnum]

export const InsuranceAmountIndexTypeEnum = {
  INSURANCE_AMOUNT: "INSURANCE_AMOUNT", // 1
  INSURANCE_RATE: "INSURANCE_RATE", // 2
} as const

// Type for the InsuranceAmountIndexTypeEnum
export type InsuranceAmountIndexTypeEnum = keyof typeof InsuranceAmountIndexTypeEnum

export const DiscountExistsEnum = {
  YES: "YES", // כן - Yes
  NO: "NO", // לא - No
  UNKNOWN: "UNKNOWN", // לא ידוע - Unknown
} as const

// Type for the DiscountExistsEnum
export type DiscountExistsEnum = (typeof DiscountExistsEnum)[keyof typeof DiscountExistsEnum]

export const DiscountTermsEnum = {
  ENTIRE_INSURANCE_PERIOD: "ENTIRE_INSURANCE_PERIOD", // הנחה לכל תקופת הביטוח - Discount for entire insurance period
  LIMITED_PERIOD: "LIMITED_PERIOD", // הנחה לתקופה קצובה - Discount for a limited period
  EMPLOYMENT_DURATION: "EMPLOYMENT_DURATION", // הנחה למשך תקופת העבודה אצל המעסיק - Discount for duration of employment
  NO_DISCOUNT: "NO_DISCOUNT", // לא ניתנה הנחה - No discount given
  EMPLOYER_CONDITIONAL_PERIOD: "EMPLOYER_CONDITIONAL_PERIOD", // הנחה לתקופה קצובה המותנית במעסיק ספציפי - Discount for limited period conditional on specific employer
} as const

// Type for the DiscountTermsEnum
export type DiscountTermsEnum = (typeof DiscountTermsEnum)[keyof typeof DiscountTermsEnum]

export const ExclusionTypeEnum = {
  MEDICAL: "MEDICAL", // כן, החרגה רפואית
  PROFESSIONAL_OR_HOBBY: "PROFESSIONAL_OR_HOBBY", // כן, מקצועית או תחביב
  NONE: "NONE", // לא קיימת
} as const

export type ExclusionTypeEnum = keyof typeof ExclusionTypeEnum

export const OccupationTypeEnum = {
  UNKNOWN: "UNKNOWN", // לא ידוע
  ALL: "ALL", // כללי
  OTHER: "OTHER", // אחר
  SPECIFIC: "SPECIFIC", // ספציפי
} as const

export type OccupationTypeEnum = keyof typeof OccupationTypeEnum

export const IndexLinkedPensionEnum = {
  UNKNOWN: "UNKNOWN",
  TWENTY_FOUR_MONTHS: "TWENTY_FOUR_MONTHS",
  THIRTY_SIX_MONTHS: "THIRTY_SIX_MONTHS",
  FORTY_EIGHT_MONTHS: "FORTY_EIGHT_MONTHS",
  SIXTY_MONTHS: "SIXTY_MONTHS",
  ALL_TIME: "ALL_TIME",
} as const

export type IndexLinkedPensionEnum = keyof typeof IndexLinkedPensionEnum

// Replace the existing currentSavingsInfoSchema definition with:
const currentSavingsInfoSchema = CurrentSavingsInfoSchema

export const InsuranceCoverage = object({
  id: number(),
  policyId: number(),
  coverageNumId: nullable(string()),
  insuranceCoverageName: nullable(string()),
  insuranceCoverageType: picklist(Object.values(InsuranceCoverageTypeEnum)),
  policyNumber: nullable(string()),
  customerId: nullable(string()),
  insuredType: nullable(picklist(Object.values(InsuredTypeEnum))),
  insuranceType: nullable(picklist(Object.values(InsuranceTypeOnManufacturerEnum))),
  insuranceCoveragePayer: nullable(picklist(Object.values(InsuranceCoveragePayerEnum))),
  coverageStartDate: nullable(string()),
  coverageEndDate: nullable(string()),
  coverageAppendixCode: nullable(string()),
  occupationType: nullable(picklist(Object.values(OccupationTypeEnum))),
  includesFranchise: nullable(boolean()),
  includesNursing: nullable(boolean()),
  indexLinkedPension: nullable(picklist(Object.values(IndexLinkedPensionEnum))),
  developingDisability: nullable(picklist(Object.values(DevelopmentalDisabilityEnum))),
  governmentSubsidyCancellation: nullable(boolean()),
  paymentEndDate: nullable(string()),
  basicInsurancePercentage: nullable(number()),
  salaryPercentage: nullable(number()),
  insurancePaymentMethod: nullable(string()),
  insuranceAmount: nullable(number()),
  ceilingAmount: nullable(number()),
  ceilingIncreasePercentage: nullable(number()),
  payload: nullable(any()),
  createdAt: string(),
  remainingCostUntilEnd: nullable(number()),
  exclusionType: nullable(string()),
  trainingPeriod: nullable(number()),
  discountExists: nullable(picklist(Object.values(DiscountExistsEnum))),
  discountTerms: nullable(picklist(Object.values(DiscountTermsEnum))),
  monthlyPayment: nullable(number()),
  insuranceAmountIndexType: nullable(picklist(Object.values(InsuranceAmountIndexTypeEnum))),
  personalGroupCoverage: nullable(picklist(Object.values(PersonalAndGroupTypeEnum))),
  waitingPeriodMonths: nullable(number()),
})
export type InsuranceCoverage = InferOutput<typeof InsuranceCoverage>

export const IncludesSavingsEnum = { YES: "YES", NO: "NO" } as const
export type IncludesSavingsEnum = keyof typeof IncludesSavingsEnum

export const basicInsuranceCoverageSchema = object({
  id: number(),
  policyId: number(),
  insuranceCoverageId: nullable(number()),
  coverageNumId: string(),
  productCode: string(),
  insuranceAmountIndexType: string(),
  insurancePremiumIndexType: string(),
  insuranceTrackType: nullable(picklist(Object.values(BasicInsuranceCoverageTrackTypeEnum))),
  includesSavings: nullable(picklist(Object.values(IncludesSavingsEnum))),
  trackInsuranceAmount: number(),
  salaryCount: nullable(number()),
  savingsAllocationPercentage: nullable(number()),
  maxDeathBenefitLimit: number(),
  deathBenefitAmount: number(),
  paymentMethod: nullable(string()),
  coverageEndDate: nullable(string()),
  monthlyCost: nullable(number()),
  remainingCostUntilEnd: nullable(number()),
  coveragePayer: nullable(picklist(Object.values(BasicInsuranceCoveragePayerEnum))),
  createdAt: string(),
  insurancePaymentMethod: nullable(string()),
  monthlyPayment: nullable(number()),
})

export type BasicInsuranceCoverage = InferOutput<typeof basicInsuranceCoverageSchema>

export const myPortfolioPolicySchema = object({
  // TODO)) delete isMock after dev
  isMock: nullish(boolean()),
  // TODO)) delete isMock after dev
  id: number(),
  productCategoryId: string(),
  policyNumberId: string(),
  planName: nullable(string()),
  policyType: nullable(string()),
  policyName: nullable(string()),
  policySavingsPercentage: nullable(number()),
  companyId: string(),
  fundId: string(),
  fundShortText: string(),
  companyLogo: string(),
  companyShortText: string(),
  joinDate: string(),
  firstJoinDate: string(),
  liquidityDate: nullable(string()),
  currentSavings: number(),
  employerName: nullable(string()),
  futureRetirementWealthWithDeposits: nullable(number()),
  futureRetirementWealthWithoutDeposits: nullable(number()),
  status: picklist(Object.values(PolicyStatusEnum)),
  posStand: nullable(picklist(Object.values(PosStandType))),
  depositManagementFees: nullable(number()),
  accManagementFees: nullable(number()),
  annualManagmentFees: nullable(number()),
  pensionFundMembershipMonths: nullable(number()),
  employeeProvision: nullable(number()),
  employerProvision: nullable(number()),
  compensationProvision: nullable(number()),
  salary: nullable(number()),
  employeeDeposits: nullable(number()),
  employerDeposits: nullable(number()),
  totalYearlyDeposits: nullable(number()),
  debt: boolean(),
  monthsOfDebt: nullable(number()),
  startOfDebtDate: nullable(string()),
  debtAmount: nullable(number()),
  loans: boolean(),
  lien: boolean(),
  bend: boolean(),
  retirementAge: number(),
  currentAllowance: nullable(number()),
  currentWealth: nullable(number()),
  futureAllowanceWithoutDeposit: nullable(number()),
  futureAllowanceWithDeposit: nullable(number()),
  monthlyFutureAllowanceWithoutDeposit: nullable(number()),
  monthlyFutureAllowanceWithDeposit: nullable(number()),
  informationValidityDate: nullable(date()),
  investmentPlans: array(InvestmentPlanSchema),
  mitriyot: optional(array(object({}))),
  basicInsuranceCoverages: array(basicInsuranceCoverageSchema),
  pensionInsuranceCoverages: array(pensionInsuranceCoveragesSchema),
  insuranceCoverages: array(InsuranceCoverage),
  currentSavingsInfo: currentSavingsInfoSchema,
  recommendationId: nullable(string()),
  includingBondEligibility: nullable(boolean()),
  designatedBondRate: nullable(number()),
  coefficientRate: nullable(number()),
  maxDepositManagementFees: nullable(number()),
  otherEmployeeProvision: nullable(number()),
  otherEmployerProvision: nullable(number()),
  otherManagmentFees: nullable(number()),
  AKAEmployerProvision: nullable(number()),
  employee47Provision: nullable(number()),
  nonInsuredPolicyOwnerName: nullable(string()),
  insurancePayerName: nullable(string()),
  insurancePaymentMethod: nullable(picklist(Object.values(InsurancePolicyPaymentMethodEnum))),
  insurancePaymentFrequency: nullable(picklist(Object.values(InsurancePolicyPaymentFrequencyEnum))),
})

export type MyPensionPortfolioPolicy = InferOutput<typeof myPortfolioPolicySchema>

export const myPortfolioDepositsSchema = object({
  depositId: number(),
  depositDate: string(),
  depositType: string(),
  depositorType: string(),
  amount: number(),
  salaryBasis: number(),
  salaryMonth: nullable(string()),
  paymentMonth: string(),
  transferringFundId: nullable(string()),
  transferringFundName: nullable(string()),
  createdAt: string(),
  payload: object({}),
})

export type MyPortfolioDeposits = InferOutput<typeof myPortfolioDepositsSchema>

export const portfolioCategoryItemSchema = object({
  category: picklist(Object.values(PensionCategoriesEnum)),
  recommendationsCount: number(),
})

export type PortfolioCategoryItem = InferOutput<typeof portfolioCategoryItemSchema>

export const myPortfolioInfoSchema = object({
  categories: array(portfolioCategoryItemSchema),
  totalAmount: number(),
})

export type MyPortfolioInfo = InferOutput<typeof myPortfolioInfoSchema>

export const myPensionExclusionSchema = object({
  exception: string(),
  createdAt: number(),
})

export type MyPensionExclusion = InferOutput<typeof myPensionExclusionSchema>

const PensionComprehensiveDepositItemSchema = object({
  month: string(),
  employeeDepositAmount: number(),
  employerDepositAmount: number(),
  totalDepositAmount: number(),
  depositCount: number(),
  accumulatedAmount: number(),
  totalAmount: number(),
})

const EmployerEmployeeDepositSchema = object({
  month: string(),
  employerDepositsAmount: number(),
  employeeDepositsAmount: number(),
  totalAmount: number(),
})

const PensionDepositsSchema = object({
  ...EmployerEmployeeDepositSchema.entries,
  pitzuimDepositsAmount: number(),
  AKADepositsAmount: number(),
})

const InvestmentDepositSchema = object({
  depositDate: string(),
  month: string(),
  totalAmount: number(),
  depositAmount: number(),
  depositCount: number(),
  depositorType: picklist(Object.values(DepositorTypeEnum)),
  depositType: picklist(Object.values(DepositTypeEnum)),
  accumulatedAmount: number(),
})

const DepositsUnionSchema = union([
  EmployerEmployeeDepositSchema,
  InvestmentDepositSchema,
  PensionDepositsSchema,
])

const PensionComprehensiveSummaryItemSchema = object({
  totalAmount: number(),
  depositCount: number(),
})

const PensionComprehensiveSummarySchema = object({
  employee: nullable(PensionComprehensiveSummaryItemSchema),
  employer: nullable(PensionComprehensiveSummaryItemSchema),
  total: PensionComprehensiveSummaryItemSchema,
})

export const PensionComprehensiveDepositsSchema = object({
  policyId: number(),
  productCategoryId: string(),
  deposits: array(DepositsUnionSchema),
  summary: PensionComprehensiveSummarySchema,
})

export type PensionComprehensiveDeposits = InferOutput<typeof PensionComprehensiveDepositsSchema>
